module.exports = __webpack_public_path__ + "static/media/icons_Bilan des dysfonctions temporo-mandibulaires.3f42d43f.svg";